// Single source of truth for FlashFonic Clinicals pricing — name, price, credits, and
// feature copy. Both the checkout modal (PlanChooserModal.jsx) and the public marketing
// page (FlashClinicalLandingPage.jsx) render from these same arrays, so a price/credit
// change only has to happen in one place instead of drifting between two hand-copied lists.
export const CLINICALS_PLANS_MONTHLY = [
    {
        id: 'class_prep_monthly', name: 'Class Prep', price: '$9.99', period: '/month',
        features: ['1,000 credits/mo', 'Smart reasoning engine for Step 1, Step 2 & Shelf', 'Full rationales & teaching points', 'Unlimited study games'],
        color: '#14B8A6', popular: false,
    },
    {
        id: 'board_review_monthly', name: 'Board Review', price: '$19.99', period: '/month',
        features: ['2,500 credits/mo', 'Advanced reasoning engine for Step 3, COMLEX 3, NCLEX & PA/NP/CRNA boards', 'Full rationales & teaching points', 'Performance analytics', 'Unlimited study games'],
        color: '#10B981', popular: true,
    },
    {
        id: 'specialty_boards_monthly', name: 'Specialty Boards', price: '$34.99', period: '/month',
        features: ['4,000 credits/mo', 'Our most powerful reasoning engine for certification & specialty exams', 'Full rationales & teaching points', 'Performance analytics', 'Unlimited study games'],
        color: '#0EA5E9', popular: false,
    },
];

export const CLINICALS_PLANS_YEARLY = [
    {
        id: 'class_prep_yearly', name: 'Class Prep', price: '$99.99', period: '/year', originalPrice: '$119.88', savings: '2 months free',
        features: ['1,000 credits/mo', 'Smart reasoning engine for Step 1, Step 2 & Shelf', 'Full rationales & teaching points', 'Unlimited study games'],
        color: '#14B8A6',
    },
    {
        id: 'board_review_yearly', name: 'Board Review', price: '$199.99', period: '/year', originalPrice: '$239.88', savings: '2 months free',
        features: ['2,500 credits/mo', 'Advanced reasoning engine for Step 3, COMLEX 3, NCLEX & PA/NP/CRNA boards', 'Full rationales & teaching points', 'Performance analytics', 'Unlimited study games'],
        color: '#10B981', popular: true,
    },
    {
        id: 'specialty_boards_yearly', name: 'Specialty Boards', price: '$349.99', period: '/year', originalPrice: '$419.88', savings: '2 months free',
        features: ['4,000 credits/mo', 'Our most powerful reasoning engine for certification & specialty exams', 'Full rationales & teaching points', 'Performance analytics', 'Unlimited study games'],
        color: '#0EA5E9',
    },
];

// Single place to update/retire the current promo — PromoBanner.jsx reads this and hides
// itself automatically once `expires` has passed, so an old code can't keep showing up on
// the marketing pages or checkout modal after it stops working in Stripe.
export const ACTIVE_PROMO = {
    code: 'FLASH30',
    headline: '30% off your first 3 months',
    detail: 'Enter code FLASH30 at checkout · new subscribers only',
    expires: '2026-09-30T23:59:59-04:00',
};

export const CLINICALS_CREDIT_PACKS = [
    { id: 'clinical_credits_50', amount: '50', price: '$1.99', color: '#14B8A6' },
    { id: 'clinical_credits_200', amount: '200', price: '$5.99', color: '#10B981', popular: true },
    { id: 'clinical_credits_500', amount: '500', price: '$12.99', color: '#0EA5E9' },
];
